import React from 'react';
import PropTypes from 'prop-types';
import RedirectChoice from './RedirectChoice';
import useRouter from '../../../hooks/useRouter';
import { LightBulbIcon } from '@heroicons/react/24/outline';

export default function GetInspiredChoice(props) {
  const { history } = useRouter();

  return (
    <RedirectChoice
      icon={LightBulbIcon}
      title="Get inspired by projects educators have brought to life."
      onClick={() => history.push({
        pathname: '/idea-hub',
      })}
    />
  );
};
